export default __webpack_public_path__ + "static/restriction-min-f12a49ef8d153dd5c3ebe60344d866e2.jpg";